import { render, staticRenderFns } from "./categories.page.vue?vue&type=template&id=58ec7d26&scoped=true&"
import script from "./categories.page.vue?vue&type=script&lang=js&"
export * from "./categories.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ec7d26",
  null
  
)

export default component.exports